var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeaderLayout',[_c('div',{staticClass:"main-page-content"},[_c('div',{staticClass:"main-page-header"},[_c('el-button',{attrs:{"type":"default","icon":"el-icon-arrow-left"},on:{"click":_vm.handleBack}},[_vm._v(" 返回 ")])],1),_c('PlcItemPanel',{attrs:{"id":_vm.id}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }